module.exports = __webpack_public_path__ + "img/chevron-left.1fab3d1a.svg";